import { filterRequestFormatter } from 'modules/interventions/utils';

import * as types from './actionTypes';
import { toMidnight, toMidnightEndOfDay } from '../../components/keydeposit/DateUtils';

export const fetchCalendarLockers = ({ from, to, dealerId, filters: allFilters }) => {
  const { date, brands, ...filters } = allFilters;

  // Transform brands array of objects to array of IDs
  const brandIds = brands && brands.length > 0
    ? brands.map(brand => (typeof brand === 'object' ? brand.id : brand))
    : brands;

  return {
    type: types.GET_LOCKERS_CALENDAR,
    payload: {
      request: {
        method: 'GET',
        url: 'vaults/api/planning',
        params: filterRequestFormatter({
          dealerId,
          from: toMidnight(from),
          to: toMidnightEndOfDay(to),
          ...filters,
          ...(brandIds && brandIds.length > 0 ? { brands: brandIds } : {}),
        }),
      },
    },
  };
};

export const fetchCalendarLockersSuccess = (date, lockers) => ({
  type: types.GET_LOCKERS_CALENDAR_SUCCESS,
  payload: {
    date,
    lockers: Array.isArray(lockers) ? lockers : [],
  },
});

export const fetchCalendarLockersError = message => ({
  type: types.GET_LOCKERS_CALENDAR_ERROR,
  payload: {
    message,
  },
  error: true,
});

export const fetchCalendarLocker = (lockerId, { from, to, dealerId, filters: allFilters }) => {
  const { date, brands, ...filters } = allFilters;

  // Transform brands array of objects to array of IDs
  const brandIds = brands && brands.length > 0
    ? brands.map(brand => (typeof brand === 'object' ? brand.id : brand))
    : brands;

  return {
    type: types.GET_LOCKER_CALENDAR,
    payload: {
      request: {
        method: 'GET',
        url: `vaults/api/${lockerId}/planning`,
        params: {
          dealerId,
          from: toMidnight(from),
          to: toMidnightEndOfDay(to),
          ...filters,
          ...(brandIds && brandIds.length > 0 ? { brands: brandIds } : {}),
        },
      },
    },
    meta: {
      lockerId,
    },
  };
};

export const fetchCalendarLockerSuccess = (date, locker) => ({
  type: types.GET_LOCKER_CALENDAR_SUCCESS,
  payload: {
    date,
    locker,
  },
});

export const fetchCalendarLockerError = message => ({
  type: types.GET_LOCKER_CALENDAR_ERROR,
  payload: {
    message,
  },
  error: true,
});

export const openCreationModal = payload => ({
  type: types.OPEN_CREATE_NEW_APPOINTMENT_MODAL,
  payload,
});

export const closeCreationModal = () => ({
  type: types.CLOSE_CREATE_NEW_APPOINTMENT_MODAL,
});

export const setSingleLockerId = lockerId => ({
  type: types.SET_SELECTED_LOCKER_ID,
  payload: lockerId,
});

export const setPlanningFilter = (field, value) => ({
  type: types.SET_PLANNING_FILTER,
  payload: { field, value },
});

export const clearPlanningFilters = () => ({
  type: types.CLEAR_PLANNING_FILTERS,
});

export const removePlanningFilter = (field, value) => ({
  type: types.REMOVE_PLANNING_FILTER,
  payload: { field, value },
});

export const nextDay = () => ({
  type: types.INCREMENT_SELECTED_DAY,
});

export const previousDay = () => ({
  type: types.DECREMENT_SELECTED_DAY,
});

export const setSelectedDate = (date, meta = {}) => ({
  type: types.SET_SELECTED_DAY,
  payload: date,
  meta,
});
